module.exports = __webpack_public_path__ + "img/hopways-02.fb822f08.jpeg";